import React, { useRef } from "react";

import { FormTextInput } from "UIComponents/InputTextField";
import UIButton from "UIComponents/UIButton";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";
import { useI18n } from "Hooks";

import classes from "./SnpVisitorSignup.scss";

const SnpVisitorSignup = props => {
  const {
    headerStyle,
    subTextStyle,
    data,
    updateInputField,
    checkEmailVerification,
    onVisitorLoginLink,
    handleSignIn,
    renderTradeMarkText,
  } = props;
  const { t } = useI18n(["common"]);

  const { email, name, password } = data;

  const emailRef = useRef();
  const usernameRef = useRef();
  const passwordRef = useRef();

  return (
    <div className={classes.container}>
      <div
        className={classes.header}
        style={headerStyle}
      >{`Sign up for Toddle`}</div>
      <div
        className={classes.subHeader}
        style={subTextStyle}
      >{`Programme evaluation team member sign up`}</div>
      <div className={classes.innerContainer}>
        <div className={classes.inputsContainer}>
          <div className={classes.inputContainer}>
            <FormTextInput
              ref={ref => (emailRef.current = ref)}
              textInputLabel={"Email"}
              value={email}
              name={"email"}
              placeholder={"Enter your email"}
              updateInputField={updateInputField}
              disabled={true}
              customValidation={checkEmailVerification}
              size={"large"}
            />
          </div>
          <div className={classes.inputContainer}>
            <FormTextInput
              ref={ref => (usernameRef.current = ref)}
              textInputLabel={"Your name"}
              value={name}
              name={"name"}
              updateInputField={updateInputField}
              disabled={true}
              size={"large"}
            />
          </div>
          <div className={classes.inputContainer}>
            <FormTextInput
              ref={ref => (passwordRef.current = ref)}
              textInputLabel={"Create password*"}
              placeholder={"Enter password"}
              name={"password"}
              value={password}
              type={"password"}
              updateInputField={updateInputField}
              size={"large"}
              error={"Enter password"}
              onEnter={handleSignIn}
            />
          </div>
        </div>
        <div className={classes.bottomContainer}>
          <div className={classNames(classes.accountText, "text-body-1")}>
            {`Already have a programme evaluation team member account?`}
            <div
              className={classNames(classes.signInText, "text-label-2")}
              onClick={onVisitorLoginLink}
              onKeyDown={e => onEnterOrSpaceKeyDown(e, onVisitorLoginLink)}
              role="button"
              tabIndex={0}
              aria-label={t("common:sign_in", { defaultValue: "Sign in" })}
            >{`Sign in`}</div>
          </div>
          <UIButton
            size={"sm"}
            type={"filled"}
            color={"pink"}
            onClick={handleSignIn}
          >{`Sign up`}</UIButton>
        </div>
      </div>
      {renderTradeMarkText({
        align: "left",
      })}
    </div>
  );
};

export default SnpVisitorSignup;
